// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
//全局loading样式表
import './assets/css/loading.css'
import util from './common/util.js'
import Print from 'vue-print-nb';
import Plugin from 'v-fit-columns';
import dataV from '@jiaminghi/data-view'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(Print);
Vue.use(Plugin);
Vue.use(dataV)
Vue.prototype.$util = util
//全局字体大小控制
Vue.prototype.$ELEMENT={size:'small'}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js